var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t("common.bic.bic_onus"),
        "show-filter": true,
        "show-refresh": true,
        "filter-expanded": _vm.displayFilter,
        "refresh-disabled": _vm.activateSpinner,
      },
      on: { "toggle-filter": _vm.toggleFilter, refresh: _vm.onRefresh },
      scopedSlots: _vm._u([
        {
          key: "primaryActions",
          fn: function () {
            return [
              _c("app-button", {
                attrs: {
                  text: _vm.$t("common.bic.bic_onus_add"),
                  icon: "fa-light fa-plus",
                  variant: "primary",
                },
                on: { click: _vm.actionAdd },
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "pageContent",
          fn: function () {
            return [
              _c("div", { staticClass: "listPage" }, [
                _c(
                  "section",
                  {
                    staticClass: "mt-4",
                    attrs: { "aria-labelledby": "results-section-title" },
                  },
                  [
                    _c(
                      "h2",
                      {
                        staticClass: "visually-hidden",
                        attrs: { id: "results-section-title" },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.results")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "12" } }, [
                          _c(
                            "div",
                            { staticClass: "table-responsive" },
                            [
                              _vm.activateSpinner
                                ? _c("spinner")
                                : _vm.listItemsBICOnus.length > 0
                                ? _c("b-table", {
                                    key: _vm.refreshKey,
                                    staticClass: "table-striped table-hover",
                                    staticStyle: { "margin-bottom": "0" },
                                    attrs: {
                                      items: _vm.listItemsBICOnus,
                                      fields: _vm.fields,
                                      selectable:
                                        _vm.listItemsBICOnus.length > 0,
                                      "empty-text": _vm.$t(
                                        "common.security.no_result"
                                      ),
                                      "sort-by": _vm.sortBy,
                                      "sort-desc": _vm.sortDir,
                                      "aria-label":
                                        _vm.$t("common.bic.bic_onus") +
                                        " - " +
                                        _vm.$t("common.table"),
                                      role: "table",
                                    },
                                    on: {
                                      "update:sortBy": function ($event) {
                                        _vm.sortBy = $event
                                      },
                                      "update:sort-by": function ($event) {
                                        _vm.sortBy = $event
                                      },
                                      "update:sortDesc": function ($event) {
                                        _vm.sortDir = $event
                                      },
                                      "update:sort-desc": function ($event) {
                                        _vm.sortDir = $event
                                      },
                                      "head-clicked": _vm.sortTable,
                                      "row-selected": _vm.onRowClicked,
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "cell(edit)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "b-button",
                                              {
                                                staticClass:
                                                  "text-center d-inline-block py-3 w-100 p-0 table-action-btn",
                                                attrs: {
                                                  variant: "link",
                                                  "aria-label":
                                                    _vm.$t("rights.edit") +
                                                    " " +
                                                    _vm.$t(
                                                      "common.global.bic"
                                                    ) +
                                                    " " +
                                                    data.item.BIC,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.actionEdit(
                                                      $event,
                                                      data.item.IdBICOnus
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa-regular fa-pencil",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(delete)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "b-button",
                                              {
                                                staticClass:
                                                  "text-center d-inline-block py-3 w-100 p-0 table-action-btn table-action-btn-danger",
                                                attrs: {
                                                  variant: "link",
                                                  "aria-label":
                                                    _vm.$t("rights.delete") +
                                                    " " +
                                                    _vm.$t(
                                                      "common.global.bic"
                                                    ) +
                                                    " " +
                                                    data.item.BIC,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.actionDelete(
                                                      $event,
                                                      data.item.IdBICOnus
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa-regular fa-trash",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  })
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-center",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "text-muted fs-5" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("common.no_result")
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "nav",
                  { attrs: { "aria-label": _vm.$t("common.pagination") } },
                  [
                    _c(
                      "b-row",
                      { staticClass: "mt-5" },
                      [
                        _c(
                          "b-col",
                          [
                            _c("cm-pagination", {
                              attrs: {
                                maxResultsByPage:
                                  _vm.paginationObject.maxResults,
                                firstIndex: _vm.paginationObject.firstIndex,
                                nbResultsTotal:
                                  _vm.paginationObject.nbResultsTotal,
                                refreshEvent: _vm.paginationObject.refresh,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "template",
        { slot: "filterContent" },
        [
          _c("app-panel", {
            attrs: {
              filters: _vm.filterConfig,
              searchAriaLabel:
                _vm.$t("common.srch") + " " + _vm.$t("common.bic.bic_onus"),
            },
            on: {
              "filter-changed": _vm.onFilterChanged,
              "clear-filters": _vm.clearFilterFields,
              "apply-filters": _vm.onRefresh,
            },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }